import { useState } from 'react';
import { faqItems } from '@/mocks/comics';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <section className="py-16 md:py-24 px-6 md:px-10 max-w-[1440px] mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 text-center">
          常见问题
        </h2>
        <p className="mt-4 text-center text-foreground-600 text-sm md:text-base">
          关于韩国漫画网的常见疑问解答
        </p>

        <div className="mt-12 md:mt-16 max-w-3xl mx-auto flex flex-col gap-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-300/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <h4 className="font-heading text-base md:text-lg font-semibold text-foreground-950 pr-4">
                  <a href={`#faq-${index}`} id={`faq-${index}`} className="no-underline">
                    {item.question}
                  </a>
                </h4>
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-transform duration-300 ${
                  openIndex === index
                    ? 'rotate-180 bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </span>
              </button>
              <div
                className={`px-6 overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'pb-5 max-h-96' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}